// extracted by mini-css-extract-plugin
export default {"barChart":"DUDDg7SHwLPgNgH8RDKF"};